import React from 'react';
import ReactDOM from 'react-dom/client';
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Auth0Provider
        domain="dev-d1aq0xw72d714fi0.us.auth0.com"
        clientId="m1SH9jfmUfiUoLrvtrb9M7YdVQ5Tsx1c"
        authorizationParams={{
          redirect_uri: window.location.origin,
          audience: "https://masho-api/",
          scope: "openid profile email read:current_user update:current_user_metadata create:current_user_metadata delete:current_user_metadata",
        }}
        cacheLocation="localstorage" // Consider using "memory" instead
        useRefreshTokens={false} // Disable refresh tokens if not needed
        skipRedirectCallback={window.location.pathname === '/callback'} // Important for proper redirects
      >
    <App />
  </Auth0Provider>,
    </BrowserRouter>
  </React.StrictMode>
);